import { useTourManager } from '@/components/blocks/TourManager';
import { DriveStep } from 'driver.js';
import { useCallback } from 'react';

const productDetailsTourSteps: DriveStep[] = [
	{
		element: '#product-details-sizes',
		popover: {
			title: 'Selecciona tu talla',
			description: 'Aquí puedes seleccionar la talla que mejor se adapte a ti.',
			showButtons: ['close'],
			nextBtnText: 'Siguiente',
			prevBtnText: 'Anterior',
			doneBtnText: 'Finalizar',
		},
	},
	{
		element: '#product-details-add-to-cart',
		popover: {
			title: 'Añadir al carrito',
			description: 'Aquí puedes añadir el producto seleccionado a tu carrito.',
			showButtons: ['close'],
			nextBtnText: 'Siguiente',
			prevBtnText: 'Anterior',
			doneBtnText: 'Finalizar',
		},
	},
	{
		element: '#header-open-cart',
		popover: {
			title: 'Tus productos',
			description: 'Aquí puedes visualizar los productos que has añadido a tu carrito.',
			showButtons: ['close'],
			nextBtnText: 'Siguiente',
			prevBtnText: 'Anterior',
			doneBtnText: 'Finalizar',
		},
	},
];

const LOCAL_STORAGE_KEY_PRODUCT_DETAILS_TOUR_COMPLETED = 'PRODUCT_DETAILS_TOUR_COMPLETED';

export const useProductDetailsTour = () => {
	const { driverInstance, onStartTour } = useTourManager();

	const onFinishProductDetailsTour = useCallback(
		(event?: any) => {
			if (driverInstance.isActive()) {
				event?.stopPropagation();
				driverInstance.destroy();
			}
		},
		[driverInstance]
	);

	const onStartProductDetailsTour = useCallback(() => {
		driverInstance.setSteps(productDetailsTourSteps);

		setTimeout(() => {
			onStartTour();
			localStorage.setItem(LOCAL_STORAGE_KEY_PRODUCT_DETAILS_TOUR_COMPLETED, 'true');
		}, 250);
	}, [onStartTour, driverInstance]);

	const onAutoStartProductDetailsTour = useCallback(() => {
		const hasCompletedTour = localStorage.getItem(LOCAL_STORAGE_KEY_PRODUCT_DETAILS_TOUR_COMPLETED);
		if (!hasCompletedTour) {
			onStartProductDetailsTour();
		}
	}, [onStartProductDetailsTour]);

	const onSelectSizeProductDetailsTour = useCallback(
		(interval?: number) => {
			if (driverInstance.isActive() && driverInstance.getActiveIndex() === 0) {
				setTimeout(() => {
					driverInstance.moveNext();
				}, interval || 0);
			}
		},
		[driverInstance]
	);

	const onAddToCartProductDetailsTour = useCallback(
		(interval?: number) => {
			if (driverInstance.isActive() && driverInstance.getActiveIndex() === 1) {
				setTimeout(() => {
					driverInstance.moveNext();
				}, interval || 0);
			}
		},
		[driverInstance]
	);

	return {
		isActiveProductDetailsTour: driverInstance.isActive(),
		onStartProductDetailsTour,
		onFinishProductDetailsTour,
		onAutoStartProductDetailsTour,
		onSelectSizeProductDetailsTour,
		onAddToCartProductDetailsTour,
	};
};
